import { emit } from '../../platform/analytics/analytics'
import type { CashflowView, Granularity } from './cashflowPeriod'
import type { DetailScope, Side } from './cashflowScope'

/** `gateShown` is true when the screen showed the free view with locked panels. */
export function emitViewed(view: CashflowView, gateShown: boolean): void {
  emit('cashflow_viewed', { period: view.granularity, gate_shown: gateShown })
}

export function emitGranularityChanged(from: Granularity, to: Granularity): void {
  emit('cashflow_granularity_changed', { from_period: from, to_period: to })
}

export function emitPeriodStepped(direction: 'prev' | 'next'): void {
  emit('cashflow_period_stepped', { direction })
}

/** No properties: an index means nothing once the history's length varies, and a date is not an enum. */
export function emitBarSelected(): void {
  emit('cashflow_bar_selected', {})
}

export function emitBreakdownViewChanged(view: 'categories' | 'groups' | 'merchants'): void {
  emit('cashflow_breakdown_view_changed', { view })
}

/** A drill-down page opened. The kind and the side only: an id or a payer's name is user data. */
export function emitDetailOpened(scope: DetailScope['kind'], side: Side): void {
  emit('cashflow_detail_opened', { scope, side })
}

export function emitMerchantExpanded(): void {
  emit('cashflow_merchant_expanded', {})
}

// A locked panel is counted by `PremiumGate`'s own `premium_gate_shown`, which
// carries `panel_kind` when the gate is given one. A second event for the same
// moment would count it twice under two names.
